import { render } from "./newAuthTelecom.vue?vue&type=template&id=48ebb62e&scoped=true"
import script from "./newAuthTelecom.vue?vue&type=script&lang=js"
export * from "./newAuthTelecom.vue?vue&type=script&lang=js"

import "./newAuthTelecom.vue?vue&type=style&index=0&id=48ebb62e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_Rhtm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ebb62e"]])

export default __exports__